/**
 * OMGS.IN-STYLE REAL-TIME PRODUCT CUSTOMIZER & E-COMMERCE ENGINE
 * GMR Gift Shop - High Conversion Mobile-First Architecture
 * Powers real product gallery, thumbnail switcher, photo preview, variant matching & 1-Click Instant Checkout
 */

// 1. Gallery Thumbnail Switcher
function changeMainImage(thumbElement, imageUrl) {
  const mainImg = document.getElementById('main-product-img');
  if (mainImg) {
    mainImg.style.opacity = '0.4';
    mainImg.src = imageUrl;
    mainImg.onload = () => {
      mainImg.style.opacity = '1';
    };
  }

  // Set active thumbnail border
  const allThumbs = document.querySelectorAll('.thumb-wrapper');
  allThumbs.forEach(t => t.classList.remove('active'));
  if (thumbElement) {
    thumbElement.classList.add('active');
  }
}

// 2. Clear Validation Error Notice
function clearCustomizationError(inputElement) {
  const alertBox = document.getElementById('customization-error-alert');
  if (alertBox) alertBox.style.display = 'none';

  if (inputElement) {
    inputElement.classList.remove('field-shake-error');
    const parent = inputElement.closest('.custom-file-dropzone, .form-group-field');
    if (parent) parent.classList.remove('field-shake-error');
  }
}

// 3. Photo Upload Instant Preview
function handlePhotoUploadPreview(input, previewBoxId, dropzoneId) {
  if (input.files && input.files[0]) {
    const file = input.files[0];
    
    // Safety check on client side
    if (!file.type || file.type.indexOf('image/') !== 0) {
      alert('Please select an image file (JPG, PNG or WEBP).');
      input.value = '';
      return;
    }
    if (file.size > 20 * 1024 * 1024) {
      alert('Photo size is too large. Please select an image under 20MB.');
      input.value = '';
      return;
    }



    const reader = new FileReader();
    reader.onload = function(e) {
      const previewBox = document.getElementById(previewBoxId);
      if (previewBox) {
        const img = previewBox.querySelector('img');
        if (img) img.src = e.target.result;
        previewBox.style.display = 'block';
      }

      // Hide dropzone placeholder text
      const dropzone = document.getElementById(dropzoneId);
      if (dropzone) {
        const textElem = dropzone.querySelector('.dropzone-text');
        if (textElem) textElem.style.display = 'none';
        dropzone.classList.remove('field-shake-error');
      }

      clearCustomizationError(input);
    };

    reader.readAsDataURL(file);
  }
}

function removePhotoUpload(inputId, previewBoxId, dropzoneTextId) {
  const input = document.getElementById(inputId);
  if (input) input.value = '';

  

  const previewBox = document.getElementById(previewBoxId);
  if (previewBox) previewBox.style.display = 'none';

  const dropzoneText = document.getElementById(dropzoneTextId);
  if (dropzoneText) dropzoneText.style.display = 'block';
}

// 4. Variant Selection Pill with Dynamic Variant Map
function selectVariantPill(btn) {
  const parentRow = btn.closest('.variant-pills-row');
  if (parentRow) {
    parentRow.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
  }

  const optionValue = btn.dataset.optionValue;
  const group = btn.closest('.variant-option-group');
  if (group) {
    const strongLabel = group.querySelector('strong');
    if (strongLabel) strongLabel.textContent = optionValue;
  }

  // Collect all selected option values across all option groups
  const allOptionGroups = document.querySelectorAll('.variant-option-group');
  const selectedOptions = [];
  allOptionGroups.forEach(g => {
    const activeBtn = g.querySelector('.variant-pill.active');
    if (activeBtn) {
      selectedOptions.push(activeBtn.dataset.optionValue);
    }
  });

  // Get dynamic variant list
  const variants = window.__productVariants || [];
  if (variants && variants.length > 0) {
    for (let v of variants) {
      let match = true;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (v.options[i] !== selectedOptions[i]) {
          match = false;
          break;
        }
      }
      if (match) {
        // Update hidden variant ID for checkout
        const hiddenInput = document.getElementById('selected-variant-id');
        if (hiddenInput) hiddenInput.value = v.id;

        // Update displayed price
        const priceEl = document.getElementById('dynamic-product-price');
        if (priceEl && v.price_formatted) {
          priceEl.textContent = v.price_formatted;
        }

        // Update compare-at price and discount badge dynamically
        const compareEl = document.querySelector('.price-row .price-compare');
        const badgeEl = document.querySelector('.price-row .badge-discount-tag');
        const stickyCompareEl = document.querySelector('.sticky-compare');
        const stickyDiscountEl = document.querySelector('.sticky-discount');

        if (v.compare_at_price && v.compare_at_price > v.price) {
          const formattedCompare = '₹' + (v.compare_at_price / 100).toLocaleString('en-IN');
          const savePct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);

          if (compareEl) {
            compareEl.textContent = formattedCompare;
            compareEl.style.display = 'inline';
          }
          if (badgeEl) {
            badgeEl.textContent = 'SAVE ' + savePct + '% OFF';
            badgeEl.style.display = 'inline-block';
          }
          if (stickyCompareEl) {
            stickyCompareEl.textContent = formattedCompare;
            stickyCompareEl.style.display = 'inline';
          }
          if (stickyDiscountEl) {
            stickyDiscountEl.textContent = savePct + '% OFF';
            stickyDiscountEl.style.display = 'inline';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
          if (stickyCompareEl) stickyCompareEl.style.display = 'none';
          if (stickyDiscountEl) stickyDiscountEl.style.display = 'none';
        }

        // Update sticky bar price
        const stickyPrice = document.querySelector('.sticky-price');
        if (stickyPrice && v.price_formatted) {
          stickyPrice.textContent = v.price_formatted;
        }
        break;
      }
    }
  }
}

// 5. STRICT VALIDATION GATE BEFORE CHECKOUT / CART ADD
function validateCustomization() {
  const form = document.getElementById('main-product-form');
  if (!form) return true;

  const alertBox = document.getElementById('customization-error-alert');
  const alertText = document.getElementById('customization-error-text');

  // Reset any prior shake classes
  document.querySelectorAll('.field-shake-error').forEach(el => el.classList.remove('field-shake-error'));

  // A. Check required Photo Uploads (Caricature, Frames, Sippers)
  const photoInputs = form.querySelectorAll('input[data-field-type="photo"]');
  for (let pInput of photoInputs) {
    if (!pInput.files || pInput.files.length === 0) {
      const errorMsg = pInput.dataset.errorMsg || 'Please upload your photo before proceeding to checkout.';
      
      if (alertBox && alertText) {
        alertText.textContent = errorMsg;
        alertBox.style.display = 'flex';
      }

      const dropzone = pInput.closest('.custom-file-dropzone') || pInput.parentElement;
      if (dropzone) {
        dropzone.classList.add('field-shake-error');
        dropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
  }

  // B. Check required Name / Text Inputs (Wallets, Custom Text)
  const nameInputs = form.querySelectorAll('input[data-field-type="name"]');
  for (let nInput of nameInputs) {
    if (!nInput.value || nInput.value.trim().length === 0) {
      const errorMsg = nInput.dataset.errorMsg || 'Please enter the name or initials to engrave before checkout.';
      
      if (alertBox && alertText) {
        alertText.textContent = errorMsg;
        alertBox.style.display = 'flex';
      }

      nInput.classList.add('field-shake-error');
      nInput.focus();
      nInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
  }

  // Validation successful
  if (alertBox) alertBox.style.display = 'none';
  return true;
}

// 6. Direct Buy Now Action -> Goes Directly to /checkout
function buyNowDirect() {
  const form = document.getElementById('main-product-form');
  if (!form) return;

  // Enforce mandatory photo/name check
  if (!validateCustomization()) {
    return;
  }
// If a photo file is selected, submit the real multipart form to /cart/add
// so properties[Photo] is preserved. Skip the AJAX fetch('/cart/add.js') path.
var photoInputs = form.querySelectorAll('input[data-field-type="photo"]');
var hasPhoto = false;
for (var i = 0; i < photoInputs.length; i++) {
  if (photoInputs[i].files && photoInputs[i].files.length > 0) {
      hasPhoto = true;
          break;
            }
            }
            if (hasPhoto) {
              var returnInput = form.querySelector('input[name="return"]');
                if (returnInput) returnInput.value = '/checkout';
                  form.submit();
                    return;
                    }
  // Show visual loading state on CTAs
  const buyBtn = document.getElementById('BuyNowBtn');
  const stickyBtn = document.getElementById('StickyBuyBtn');
  const originalBuyText = buyBtn ? buyBtn.innerHTML : '';
  const originalStickyText = stickyBtn ? stickyBtn.innerHTML : '';

  if (buyBtn) {
    buyBtn.innerHTML = '⚡ Opening Checkout...';
    buyBtn.disabled = true;
    buyBtn.style.opacity = '0.75';
  }
  if (stickyBtn) {
    stickyBtn.innerHTML = '⚡ Opening Checkout...';
    stickyBtn.disabled = true;
    stickyBtn.style.opacity = '0.75';
  }

  // Use native return_to fallback helper
  function triggerNativeCheckoutFallback() {
    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.appendChild(returnInput);
    }
    returnInput.value = '/checkout';
    form.submit();
  }

  try {
    const formData = new FormData(form);
    
    // For direct Buy Now: clear prior accumulated test items first, so checkout contains ONLY this customized gift
    fetch('/cart/clear.js', { method: 'POST' })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
    })
    .then(res => {
      if (!res.ok) {
        throw new Error('Cart add response not ok: ' + res.status);
      }
      return res.json();
    })
    .then(() => {
      // Direct instant redirection to checkout
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.warn('AJAX cart add error, falling back to native checkout submission:', err);
      triggerNativeCheckoutFallback();
    });
  } catch (e) {
    console.warn('FormData fetch failed, using direct form submit:', e);
    triggerNativeCheckoutFallback();
  }
}

// 7. Mobile Sticky Bar Buy Action -> Directly triggers buyNowDirect for instant checkout
function triggerMobileBuy() {
  buyNowDirect();
}

// Initialize on DOM Ready
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('main-product-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      if (!validateCustomization()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // For Add to Cart button
      const addBtn = document.getElementById('AddToCart');
      if (addBtn) {
        addBtn.innerHTML = '🛍️ Adding to Cart...';
        addBtn.style.opacity = '0.8';
      }
    });
  }

  // Gift wrap toggle message box
  const giftWrapCheck = document.getElementById('gift-wrap-check');
  const giftMsgWrap = document.getElementById('gift-message-wrapper');
  if (giftWrapCheck && giftMsgWrap) {
    giftWrapCheck.addEventListener('change', () => {
      giftMsgWrap.style.display = giftWrapCheck.checked ? 'block' : 'none';
    });
  }
});

/* ==========================================================================
   8. LIVE PREVIEW ENGINE (PHOTO-ON-PRODUCT SIMULATION, OMGS.IN STYLE)
   Draws the customer's selected photo and text onto product mockup stages
   in real time inside the browser. Files are never uploaded to Shopify;
   the customer sends the photo on WhatsApp after placing the order.
   ========================================================================== */
(function () {
  'use strict';

  function lvEl(id) { return document.getElementById(id); }

  function lvSetPlaceholder(el, isEmpty) {
    if (el) el.classList.toggle('lv-placeholder-state', !!isEmpty);
  }

  // Re-triggers a one-shot CSS animation class (restarts it if already running).
  function lvReplayAnim(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  // Fast separable box blur on a Float32 grayscale buffer (sketch filter step).
  function lvBoxBlur(src, w, h, r) {
    var tmp = new Float32Array(w * h);
    var out = new Float32Array(w * h);
    var d = 2 * r + 1;
    var x, y, sum, row, xr, xl, yb, yt;
    for (y = 0; y < h; y++) {
      row = y * w;
      sum = 0;
      for (x = -r; x <= r; x++) sum += src[row + Math.min(w - 1, Math.max(0, x))];
      for (x = 0; x < w; x++) {
        tmp[row + x] = sum / d;
        xr = Math.min(w - 1, x + r + 1);
        xl = Math.max(0, x - r);
        sum += src[row + xr] - src[row + xl];
      }
    }
    for (x = 0; x < w; x++) {
      sum = 0;
      for (y = -r; y <= r; y++) sum += tmp[Math.min(h - 1, Math.max(0, y)) * w + x];
      for (y = 0; y < h; y++) {
        out[y * w + x] = sum / d;
        yb = Math.min(h - 1, y + r + 1);
        yt = Math.max(0, y - r);
        sum += tmp[yb * w + x] - tmp[yt * w + x];
      }
    }
    return out;
  }

  // Charcoal / pencil sketch simulation (grayscale color-dodge technique).
  function lvGenerateSketch(img, cb) {
    try {
      var maxW = 720;
      var scale = Math.min(1, maxW / (img.naturalWidth || maxW));
      var w = Math.max(1, Math.round((img.naturalWidth || maxW) * scale));
      var h = Math.max(1, Math.round((img.naturalHeight || maxW) * scale));
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var imageData = ctx.getImageData(0, 0, w, h);
      var p = imageData.data;
      var n = w * h;
      var gray = new Float32Array(n);
      var inv = new Float32Array(n);
      var i;
      for (i = 0; i < n; i++) {
        var v = 0.299 * p[i * 4] + 0.587 * p[i * 4 + 1] + 0.114 * p[i * 4 + 2];
        gray[i] = v;
        inv[i] = 255 - v;
      }
      var blurred = lvBoxBlur(inv, w, h, Math.max(4, Math.round(Math.min(w, h) / 42)));
      for (i = 0; i < n; i++) {
        var out = (gray[i] * 255) / (255 - blurred[i] + 1);
        if (out > 255) out = 255;
        out = (out - 128) * 1.14 + 128;
        if (out < 0) out = 0;
        else if (out > 255) out = 255;
        p[i * 4] = p[i * 4 + 1] = p[i * 4 + 2] = out;
        p[i * 4 + 3] = 255;
      }
      ctx.putImageData(imageData, 0, 0);
      cb(canvas.toDataURL('image/jpeg', 0.92));
    } catch (err) {
      cb(null);
    }
  }

  /* ---------- Photo-on-product stage (frame / avatar stand / bottle) ---------- */

  function lvInitPhotoStage(spec) {
    var stage = lvEl(spec.stageId);
    if (!stage) return;

    var input = lvEl(spec.inputId);
    var photoImg = lvEl(spec.imgId);
    var placeholder = lvEl(spec.placeholderId);
    var win = lvEl(spec.windowId);
    var zoomRow = spec.zoomRowId ? lvEl(spec.zoomRowId) : null;
    var zoomSlider = spec.zoomId ? lvEl(spec.zoomId) : null;
    var resetBtn = spec.resetId ? lvEl(spec.resetId) : null;
    var sketchImg = spec.sketchId ? lvEl(spec.sketchId) : null;
    var modesRow = spec.modesId ? lvEl(spec.modesId) : null;
    if (!input || !photoImg || !placeholder || !win) return;

    var state = { scale: 1, x: 0, y: 0, sourceImg: null, sketchUrl: null, mode: 'photo' };

    function applyTransform() {
      var t = 'translate(' + state.x + 'px,' + state.y + 'px) scale(' + state.scale + ')';
      photoImg.style.transform = t;
      if (sketchImg) sketchImg.style.transform = t;
    }

    function clampPan() {
      var maxX = (win.clientWidth * (state.scale - 1)) / 2;
      var maxY = (win.clientHeight * (state.scale - 1)) / 2;
      if (state.x > maxX) state.x = maxX;
      if (state.x < -maxX) state.x = -maxX;
      if (state.y > maxY) state.y = maxY;
      if (state.y < -maxY) state.y = -maxY;
    }

    function resetView() {
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      if (zoomSlider) zoomSlider.value = 1;
      applyTransform();
    }

    function setMode(mode) {
      if (!sketchImg) return;
      if (mode === 'sketch' && !state.sketchUrl && state.sourceImg) {
        lvGenerateSketch(state.sourceImg, function (url) {
          if (url) {
            state.sketchUrl = url;
            sketchImg.src = url;
            setMode('sketch');
          }
        });
        return;
      }
      state.mode = mode;
      var showSketch = mode === 'sketch' && !!state.sketchUrl;
      sketchImg.style.display = showSketch ? 'block' : 'none';
      photoImg.style.display = showSketch ? 'none' : 'block';
      // Pop only in the default view; mid-zoom the animation transform would
      // briefly override the user's pan/zoom.
      if (state.scale === 1 && state.x === 0 && state.y === 0) {
        lvReplayAnim(showSketch ? sketchImg : photoImg, 'lv-anim-pop');
      }
      var pb = spec.modePhotoId ? lvEl(spec.modePhotoId) : null;
      var sb = spec.modeSketchId ? lvEl(spec.modeSketchId) : null;
      if (pb) pb.classList.toggle('active', !showSketch);
      if (sb) sb.classList.toggle('active', showSketch);
    }

    function showPhoto(dataUrl) {
      var im = new Image();
      im.onload = function () {
        state.sourceImg = im;
        state.sketchUrl = null;
        photoImg.src = dataUrl;
        photoImg.style.display = 'block';
        if (sketchImg) {
          sketchImg.style.display = 'none';
          sketchImg.removeAttribute('src');
        }
        placeholder.style.display = 'none';
        win.classList.add('lv-has-photo');
        if (zoomRow) { zoomRow.style.display = 'flex'; lvReplayAnim(zoomRow, 'lv-anim-drop'); }
        if (modesRow) { modesRow.style.display = 'flex'; lvReplayAnim(modesRow, 'lv-anim-drop'); }
        setMode('photo');
        resetView();
        lvReplayAnim(photoImg, 'lv-anim-pop');
        var hint = win.querySelector('.lv-drag-hint');
        if (hint) {
          hint.classList.add('lv-show');
          setTimeout(function () { hint.classList.remove('lv-show'); }, 2600);
        }
      };
      im.src = dataUrl;
    }

    function clearPhoto() {
      photoImg.removeAttribute('src');
      photoImg.style.display = 'none';
      photoImg.classList.remove('lv-anim-pop');
      if (sketchImg) {
        sketchImg.style.display = 'none';
        sketchImg.removeAttribute('src');
        sketchImg.classList.remove('lv-anim-pop');
      }
      placeholder.style.display = 'flex';
      win.classList.remove('lv-has-photo');
      if (zoomRow) { zoomRow.style.display = 'none'; zoomRow.classList.remove('lv-anim-drop'); }
      if (modesRow) { modesRow.style.display = 'none'; modesRow.classList.remove('lv-anim-drop'); }
      state.sourceImg = null;
      state.sketchUrl = null;
      resetView();
    }

    // Photo picked in the main dropzone -> draw it onto the product mockup.
    input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      if (!f) { clearPhoto(); return; }
      var reader = new FileReader();
      reader.onload = function (e) { showPhoto(e.target.result); };
      reader.readAsDataURL(f);
    });

    // "Change Photo" tag inside the small thumbnail resets the stage too.
    var field = input.closest('.form-group-field');
    var removeTag = field ? field.querySelector('.remove-photo-tag') : null;
    if (removeTag) removeTag.addEventListener('click', function () { clearPhoto(); });

    if (zoomSlider) {
      zoomSlider.addEventListener('input', function () {
        state.scale = parseFloat(zoomSlider.value) || 1;
        clampPan();
        applyTransform();
      });
    }
    if (resetBtn) resetBtn.addEventListener('click', resetView);

    var dragging = false, startX = 0, startY = 0, origX = 0, origY = 0;
    win.addEventListener('pointerdown', function (e) {
      if (!state.sourceImg || e.button > 0) return;
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      origX = state.x;
      origY = state.y;
      win.classList.add('lv-dragging');
      if (win.setPointerCapture) {
        try { win.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
    });
    win.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      state.x = origX + (e.clientX - startX);
      state.y = origY + (e.clientY - startY);
      clampPan();
      applyTransform();
    });
    function endDrag() {
      dragging = false;
      win.classList.remove('lv-dragging');
    }
    win.addEventListener('pointerup', endDrag);
    win.addEventListener('pointercancel', endDrag);

    // Sketch / photo mode toggle buttons (frames only).
    if (spec.modePhotoId && spec.modeSketchId) {
      var mp = lvEl(spec.modePhotoId);
      var ms = lvEl(spec.modeSketchId);
      if (mp) mp.addEventListener('click', function () { if (state.sourceImg) setMode('photo'); });
      if (ms) ms.addEventListener('click', function () { if (state.sourceImg) setMode('sketch'); });
    }
  }

  /* ---------- Wallet stage (live photo print + name plate + charm) ---------- */

  function lvInitWalletStage() {
    var nameEl = lvEl('lv-wallet-name');
    if (!nameEl) return;

    var nameInput = lvEl('wallet-name-input');
    var fontSel = lvEl('wallet-font-select');
    var charmSel = lvEl('wallet-charm-select');
    var charmEl = lvEl('lv-wallet-charm');
    var photoInput = lvEl('wallet-photo-upload');
    var printWrap = lvEl('lv-wallet-print-wrap');
    var printImg = lvEl('lv-wallet-print-img');
    var printPh = lvEl('lv-wallet-print-ph');

    function syncName(animate) {
      var v = nameInput ? (nameInput.value || '').trim() : '';
      nameEl.textContent = v ? v.toUpperCase() : 'YOUR NAME';
      lvSetPlaceholder(nameEl, !v);
      if (animate && v) lvReplayAnim(nameEl, 'lv-anim-pop-text');
    }
    if (nameInput) {
      nameInput.addEventListener('input', function () { syncName(true); });
      syncName(false);
    }

    var FONT_CLASSES = ['lv-font-serif', 'lv-font-modern', 'lv-font-cursive', 'lv-font-mono'];
    function syncFont(animate) {
      nameEl.classList.remove.apply(nameEl.classList, FONT_CLASSES);
      if (!fontSel) return;
      var v = fontSel.value || '';
      if (v.indexOf('Playfair') !== -1) nameEl.classList.add('lv-font-serif');
      else if (v.indexOf('Poppins') !== -1) nameEl.classList.add('lv-font-modern');
      else if (v.indexOf('Brush') !== -1) nameEl.classList.add('lv-font-cursive');
      else if (v.indexOf('Cinzel') !== -1) nameEl.classList.add('lv-font-mono');
      if (animate) lvReplayAnim(nameEl, 'lv-anim-pop-text');
    }
    if (fontSel) {
      fontSel.addEventListener('change', function () { syncFont(true); });
      syncFont(false);
    }

    function syncCharm(animate) {
      if (!charmEl || !charmSel) return;
      var v = charmSel.value || '';
      if (v === 'None' || v === '') { charmEl.style.display = 'none'; return; }
      var parts = v.trim().split(/\s+/);
      charmEl.style.display = 'block';
      charmEl.textContent = parts[parts.length - 1];
      if (animate) lvReplayAnim(charmEl, 'lv-anim-pop-text');
    }
    if (charmSel) {
      charmSel.addEventListener('change', function () { syncCharm(true); });
      syncCharm(false);
    }

    function showPrint(src) {
      if (!printWrap) return;
      if (!src) {
        if (printImg) { printImg.style.display = 'none'; printImg.removeAttribute('src'); }
        if (printPh) printPh.style.display = 'flex';
        return;
      }
      if (printImg) { printImg.src = src; printImg.style.display = 'block'; }
      if (printPh) printPh.style.display = 'none';
      lvReplayAnim(printWrap, 'lv-anim-pop');
    }

    if (photoInput && printWrap) {
      photoInput.addEventListener('change', function () {
        var f = photoInput.files && photoInput.files[0];
        if (!f) { showPrint(null); return; }
        var reader = new FileReader();
        reader.onload = function (e) { showPrint(e.target.result); };
        reader.readAsDataURL(f);
      });
      var field = photoInput.closest('.form-group-field');
      var removeTag = field ? field.querySelector('.remove-photo-tag') : null;
      if (removeTag) removeTag.addEventListener('click', function () { showPrint(null); });
    }
  }

  /* ---------- Text fields mirrored onto a stage element ---------- */

  function lvBindText(inputId, elId, placeholderText) {
    var input = lvEl(inputId);
    var el = lvEl(elId);
    if (!input || !el) return;
    function sync() {
      var v = (input.value || '').trim();
      el.textContent = v ? v : placeholderText;
      lvSetPlaceholder(el, !v);
    }
    input.addEventListener('input', sync);
    sync();
  }

  /* ---------- Boot ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    lvInitPhotoStage({
      stageId: 'lv-frame-stage',
      inputId: 'frame-photo-upload',
      imgId: 'lv-frame-photo',
      sketchId: 'lv-frame-sketch',
      placeholderId: 'lv-frame-placeholder',
      windowId: 'lv-frame-window',
      zoomRowId: 'lv-frame-zoomrow',
      zoomId: 'lv-frame-zoom',
      resetId: 'lv-frame-reset',
      modesId: 'lv-frame-modes',
      modePhotoId: 'lv-mode-photo',
      modeSketchId: 'lv-mode-sketch'
    });
    lvBindText('frame-caption-input', 'lv-frame-caption', 'Your caption here');

    lvInitPhotoStage({
      stageId: 'lv-av-stage',
      inputId: 'caricature-photo-upload',
      imgId: 'lv-av-photo',
      placeholderId: 'lv-av-placeholder',
      windowId: 'lv-av-window',
      zoomRowId: 'lv-av-zoomrow',
      zoomId: 'lv-av-zoom',
      resetId: 'lv-av-reset'
    });
    lvBindText('caricature-base-name', 'lv-av-name', 'YOUR NAME');

    lvInitPhotoStage({
      stageId: 'lv-bottle-stage',
      inputId: 'bottle-photo-upload',
      imgId: 'lv-bottle-photo',
      placeholderId: 'lv-bottle-placeholder',
      windowId: 'lv-bottle-window',
      zoomRowId: 'lv-bottle-zoomrow',
      zoomId: 'lv-bottle-zoom',
      resetId: 'lv-bottle-reset'
    });
    lvBindText('bottle-name-input', 'lv-bottle-name', 'YOUR NAME');

    lvInitWalletStage();
  });
})();

/* ==========================================================================
   10. MODERN MOTION ENGINE (SCROLL REVEALS, CTA SHINE, IMAGE FADES)
   Progressive enhancement: hidden states apply only when JS runs
   (html.gmr-anim), every reveal is cleaned up after it finishes so native
   hover effects keep working, and safety timers guarantee content can
   never stay invisible. Disabled entirely for prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addToAll(selector, className) {
    var list = document.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) list[i].classList.add(className);
  }

  // A. CTA shine sweep (hover) + periodic shimmer on primary Buy buttons.
  addToAll('.btn-primary, .btn-hero-secondary, .btn-slide-cta, .btn-primary-add-cart, .btn-catalog-personalize, .btn-personalize-card, .btn-instagram-follow, .btn-designer-wa', 'gmr-shine');
  addToAll('.btn-buy-now-direct, .btn-hero-primary, .sticky-buy-btn', 'gmr-shimmer');

  // B. Soft fade-in for catalog images once loaded (never leaves one hidden).
  (function () {
    var imgs = document.querySelectorAll('.luxury-card-media img, .tile-image-wrapper img, .catalog-card-image img, .card-thumb img, .collection-grid-mobile img, .story-inner-img img');
    function reveal(img) { img.classList.add('gmr-imgdone'); }
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        img.classList.add('gmr-imgload');
        if (img.complete && img.naturalWidth > 0) { reveal(img); return; }
        img.addEventListener('load', function () { reveal(img); }, { once: true });
        img.addEventListener('error', function () { reveal(img); }, { once: true });
        setTimeout(function () { reveal(img); }, 4000);
      })(imgs[i]);
    }
  })();

  // C. Scroll reveal engine.
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('gmr-anim');

  var GROUPS = [
    { sel: '.hero-badge-pill', base: 60 },
    { sel: '.hero-perks-row', base: 200 },
    { sel: '.hero-action-buttons', base: 300 },
    { sel: '.hero-security-note', base: 380 },
    { sel: '.section-heading, .luxury-cat-header, .instagram-profile-header', base: 0 },
    { sel: '.badge-item', step: 70 },
    { sel: '.story-circle-item', step: 45 },
    { sel: '.luxury-cat-card', step: 80 },
    { sel: '.step-card', step: 90 },
    { sel: '.designer-help-banner', base: 120 },
    { sel: '.featured-catalog-card, .related-product-card', step: 70 },
    { sel: '.review-card', step: 80 },
    { sel: '.wallet-review-card', step: 55 },
    { sel: '.faq-item', step: 55 },
    { sel: '.instagram-tile-card', step: 65 },
    { sel: '.instagram-social-strip, .reviews-bottom-guarantee', base: 120 },
    { sel: '.collection-grid-mobile > div', step: 60 },
    { sel: '.seo-story-section .container > div', step: 80 }
  ];

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var el = entries[i].target;
      if (!entries[i].isIntersecting) continue;
      io.unobserve(el);
      el.classList.add('gmr-in');
      (function (node) {
        var done = false;
        function cleanup() {
          if (done) return;
          done = true;
          node.removeEventListener('transitionend', cleanup);
          node.classList.remove('gmr-in');
          node.classList.remove('gmr-reveal');
          node.style.removeProperty('--gmr-d');
        }
        node.addEventListener('transitionend', cleanup);
        setTimeout(cleanup, 1800);
      })(el);
    }
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

  try {
    for (var g = 0; g < GROUPS.length; g++) {
      var conf = GROUPS[g];
      var els = document.querySelectorAll(conf.sel);
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        var parent = el.parentNode || document.body;
        var idx = parent.gmrStaggerIndex || 0;
        parent.gmrStaggerIndex = idx + 1;
        var delay = (conf.base || 0) + Math.min(idx * (conf.step || 60), 420);
        el.style.setProperty('--gmr-d', delay + 'ms');
        el.classList.add('gmr-reveal');
        io.observe(el);
      }
    }
  } catch (err) {
    addToAll('.gmr-reveal', 'gmr-in');
  }

  // D. Safety nets — content can never stay hidden.
  setTimeout(function () {
    var pending = document.querySelectorAll('.gmr-reveal:not(.gmr-in)');
    var vh = window.innerHeight || 800;
    for (var i = 0; i < pending.length; i++) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > -60) pending[i].classList.add('gmr-in');
    }
  }, 2400);
  setTimeout(function () {
    addToAll('.gmr-reveal:not(.gmr-in)', 'gmr-in');
  }, 9000);
})();
